"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DebugBar = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

// NoteReview(simon): convert to function component
var DebugBar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(DebugBar, _React$Component);

  function DebugBar(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, DebugBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(DebugBar).call(this, props));
    var _props$djreactState = props.djreactState,
        env = _props$djreactState.env,
        debug = _props$djreactState.debug;
    _this.state = {
      show: debug && env === 'development'
    };
    return _this;
  }

  (0, _createClass2["default"])(DebugBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.show === false) {
        var show = window.location.search.includes('?debug=1');
        this.setState({
          show: show
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.state.show) {
        return null;
      } // NotePrototype(simon): read from context?


      var djreactState = this.props.djreactState;
      var errors = djreactState.errors;
      var hasErrors = errors && errors.length > 0;
      return React.createElement("div", {
        style: {
          position: 'fixed',
          zIndex: 5000,
          bottom: 0,
          right: 0,
          background: 'rgba(232, 232, 232, 0.2)',
          padding: 12,
          maxWidth: 250
        }
      }, React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }
      }, React.createElement("div", null, "djreact debug bar"), React.createElement("div", {
        style: {
          width: '1em'
        }
      }), React.createElement("button", {
        onClick: function onClick() {
          _this2.setState({
            show: false
          });
        }
      }, "\xD7")), React.createElement("hr", null), React.createElement("table", null, React.createElement("tbody", null, React.createElement("tr", null, React.createElement("th", null, "logged in"), React.createElement("td", null, djreactState.logged ? 'YES' : 'NO')), React.createElement("tr", null, React.createElement("th", null, "language"), React.createElement("td", null, djreactState.language)), React.createElement("tr", null, React.createElement("th", null, "device"), React.createElement("td", null, djreactState.device)), React.createElement("tr", null, React.createElement("th", null, "version"), React.createElement("td", null, djreactState.version)), React.createElement("tr", null, React.createElement("th", null, "env"), React.createElement("td", null, djreactState.env)), React.createElement("tr", null, React.createElement("th", null, "render"), React.createElement("td", null, djreactState.render)), React.createElement("tr", null, React.createElement("th", null, "errors"), React.createElement("td", null, hasErrors ? djreactState.errors.join(', ') : '-')))));
    }
  }]);
  return DebugBar;
}(React.Component);

exports.DebugBar = DebugBar;